export default {

    isNullOrEmpty(str) {
        return !str || str === null || str === "" || Array.isArray(str) || str.trim() === "";
    }
}